import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import callbackImage from '../media/home/callback.jpg';
import '../styles/callback.css';
import { useState } from 'react';
import { ToastContainer, toast,Bounce } from 'react-toastify';

function Callback() {
  const [callbackForm, setCallbackForm] = useState({
    client_name: '',
    client_email: '',
    client_phone: '',
    service_required: '',
    message: '',
  });

  const [disabled, setDisabled] = useState(false);
  // const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setCallbackForm({ ...callbackForm, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);

    try {
      callbackForm.p_id = '1005'; 
      const response = await fetch('https://commandx-backend.vercel.app/mail/contactmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(callbackForm),
      });

      if (response.ok) {
        // setSubmitted(true);
        toast.success('Your message has been sent!', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                        });
        setCallbackForm({
          client_name: '',
          client_email: '',
          client_phone: '',
          service_required: '',
          message: '',
        });
        setDisabled(false);
      } else {
         toast.error('Failed to send message!', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                        });
        setDisabled(false);
      }
    } catch (error) {
       toast.error('An error occured!', {
                      position: "bottom-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                      transition: Bounce,
                      });
      setDisabled(false);
    }

    setDisabled(false);
  };

  return (
    <section
      className="callback-section py-5 position-relative"
      style={{ backgroundImage: `url(${callbackImage})` }}
    >
      <br /><br />
      <div className="overlay"></div>
      <Container className="position-relative">
        <Row>
          <Col md={6}>
            <h2 className="text-dark mb-4" style={{ fontSize: "30px" }}>
              REQUEST A FREE<br /><span style={{ color: "#2E3192" }}>CALL BACK</span>
            </h2>
            <br />
            <p>
              Provide discussion information and we’ll<br />get back to you as soon as possible.
            </p>
          </Col>
          <Col md={6} className="text-center">
            <br /><br />
            <Form className="callback-form mx-auto" onSubmit={handleSubmit}>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Group controlId="formName">
                    <Form.Label className="visually-hidden">Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Your Name"
                      name="client_name"
                      value={callbackForm.client_name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="formService">
                    <Form.Label className="visually-hidden">Service</Form.Label>
                    <Form.Select
                      required
                      name="service_required"
                      value={callbackForm.service_required}
                      onChange={handleChange}
                    >
                      <option value="" disabled>Select a Service</option>
                      <option value="Accounting & Bookkeeping">Accounting & Bookkeeping</option>
                      <option value="VAT & Corporate Tax Compliance">VAT & Corporate Tax Compliance</option>
                      <option value="Payroll Management">Payroll Management</option>
                      <option value="Data Analytics & Business Intelligence">Data Analytics & Business Intelligence</option>
                      <option value="Internal Audit Services">Internal Audit Services</option>
                      <option value="CFO Services">CFO Services</option>
                      <option value="Audit Liaison & Final Reports">Audit Liaison & Final Reports</option>
                      <option value="AML & Compliance Services">AML & Compliance Services</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="formEmail">
                    <Form.Label className="visually-hidden">Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email Id"
                      name="client_email"
                      value={callbackForm.client_email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="formPhone">
                    <Form.Label className="visually-hidden">Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Phone Number"
                      name="client_phone"
                      value={callbackForm.client_phone}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xs={12}>
                  <Form.Group controlId="formMessage">
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Your Message"
                      name="message"
                      value={callbackForm.message}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xs={12}>
                  <Button type="submit" className="w-100" disabled={disabled}>
                    {disabled ? 'Submitting...' : 'Submit'}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
      <br /><br />
      <ToastContainer
                          position="bottom-right"
                          autoClose={5000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick={false}
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="light"
                          transition={Bounce}
          />
    </section>
  );
}

export default Callback;
